import { skipToken, } from '@tanstack/react-query';
import { getToken } from '../../auth';
import { useGetApiUser, } from '../../generated/sitComponents';
import { CACHE_TIMES, PERSIST_META } from '../query';
/**
 * @deprecated This is not actually deprecated. Instead, you should use a custom hook that wraps `useGetUser` and overrides the `requestConfig` to handle unauthorized errors.
 * For web, that's `@web/api/users/use-get-user`.
 */
export function useGetUser(variables, options) {
    // While it's always best to check `isAuthenticated` before calling this hook, we also check the token here.
    // We have frequently had runtime `Unauthorized` errors returned from the SIT API because we accidentally call
    // this hook when the user is not authenticated.
    // While we should always try and check `isAuthenticated` before calling this hook, especially since those checks respect the react hook lifecycle,
    // we also check the token here to prevent runtime errors.
    // This code is here and not in all the other hooks simply because this code is more likely to be called in pages that users aren't authenticated on.
    const token = getToken();
    return useGetApiUser(token ? (variables ?? {}) : skipToken, {
        staleTime: CACHE_TIMES.ONE_MINUTE,
        // We want to cache the user data indefinitely so that an authenticated user is always authenticated
        // unless explicitly logged out.
        gcTime: Number.POSITIVE_INFINITY,
        ...options,
        retry: (failureCount, error) => {
            if (error.status === 401 ||
                error.status === 403 ||
                error.status === 429) {
                return false;
            }
            return failureCount < 3;
        },
        meta: PERSIST_META,
    });
}
//# sourceMappingURL=use-get-user.js.map